var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback-fixed-btn"},[_c('router-link',{attrs:{"to":_vm.$i18nRoute({ name: 'feedback-add' })}},[_c('span',{staticClass:"feedback-icon"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }